import Axios from '@/services/axios-instance/axios.service';

class ApplicationsService {
  async findApplication(req) {
    const { data } = await Axios.post('/applications/find-application', req);
    return data;
  }
  async createApplication(req) {
    const { data } = await Axios.post('/applications/create-application', req);
    return data;
  }
  async createReapplyApplicationRecords(req) {
    const { data } = await Axios.post('/applications/create-reapply-application-records', req);
    return data;
  }
  async createPkPayment(req) {
    const { data } = await Axios.post('/applications/create-pk-payment', req);
    return data;
  }
  async createPaymentMethod(req) {
    const { data } = await Axios.post('/applications/update-payment-method-after-registration', req);
    return data;
  }
  async getPkApplication(req) {
    const { data } = await Axios.post('/applications/get-pk-application', req);
    return data;
  }
  async checkApplicationBeforePayment(req) {
    const { data } = await Axios.post('/applications/check-application-before-payment', req);
    return data;
  }
  async savePkApplication(req) {
    const { data } = await Axios.post('/applications/save-pk-application', req);
    return data;
  }
}

export default new ApplicationsService();
